import { createReducer } from '@reduxjs/toolkit';
import { initializePrice } from './actions';

const price = createReducer(
  {
    costPriceList: [],
    coupon: null,
    freeQuantityRatio: 0,
    hasNavInkDiscount: false,
    isClearance: false,
    isCouponApplied: false,
    isCustomerPrice: false,
    isEveryDayLowPrice: false,
    itemPriceCode: null,
    priceTable: [],
  },
  (builder) => {
    builder.addCase(initializePrice, (state, action) => action.payload);
  }
);

const priceReducer = { price };
export default priceReducer;
